import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BucketS3Service } from '@shared/services/bucket-s3.service';
import { PricingService } from '@shared/services/pricing.service';
import { FunctionsService } from '@shared/services/functions.service';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/redux/config-store-state.model';
import { TranslateService } from '@ngx-translate/core';
import { CartStorage, BookMerge } from '@shared/services/cart-storage.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'astrea-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss']
})
export class CartItemComponent implements OnInit, OnDestroy {

  @Output() updateItem = new EventEmitter<CartStorage>();
  @Output() deleteItem = new EventEmitter<CartStorage>();
  @Input() bookMerge!: BookMerge;

  public book!: any;
  public cart!: CartStorage;

  public count!: number;
  public countMin!: number
  public countMax!: number
  public unitPrice!: number;
  public finalPrice!: number;

  private countBooks$: Subject<void> = new Subject<void>();

  constructor(
    public S3Service: BucketS3Service,
    public fnService: FunctionsService,
    public pricingService: PricingService,
    private store: Store<AppState>,
    private _t: TranslateService,
  ) { }

  ngOnInit(): void {
    this.book = this.bookMerge.bookInfo;
    this.cart = this.bookMerge.cartInfo;
    this.listenCountBooks();

    this.store.select(state => state.storeConfig.currency)
      .subscribe({
        next: () => {
          this.setInitialPrice();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.countBooks$) this.countBooks$.complete();
  }

  handleDeleteItem(): void {
    this.deleteItem.emit(this.cart);
  }


  /* ********** PRICING ********** */

  setInitialPrice(): void {
    this.count = this.cart ? this.cart?.count : 1;

    if (this.cart.typeStorage == 'physical_book') {
      this.countMin = 1;
      this.countMax = 5;
      this.unitPrice = this.pricingService.getWebPricing(this.book);
    } else if (this.cart.typeStorage == 'digital_book') {
      this.countMin = 3;
      this.countMax = 24;
      this.unitPrice = this.pricingService.getAVPricing(this.book);
    }

    this.finalPrice = this.unitPrice * (this.cart ? this.cart.count : 1);
  }

  handleCountBooks(count: number): void {
    if (this.countMin <= count && count <= this.countMax) {
      this.count = count;
      this.finalPrice = this.unitPrice * (this.cart ? count : 1);
      this.countBooks$.next();
    }
  }

  listenCountBooks(): void {
    this.countBooks$
      .pipe(
        debounceTime(750)
      )
      .subscribe({
        next: () => {
          const cart: CartStorage = {
            bookcode: this.book.bookcode,
            typeStorage: this.cart.typeStorage,       // HAY QUE MEJORAR ESTO
            count: this.count,
          };
          this.updateItem.emit(cart);
        }
      });
  }


  /* ********** FUNCTIONS ********** */

  getBookType(booktype: string): string {
    switch (booktype) {
      case 'A' : case 'D' : { return this._t.instant('books.type.doctrine'); }
      case 'B' : { return this._t.instant('books.type.book'); }
      case 'M' : { return this._t.instant('books.type.article'); }
      case 'J' : { return this._t.instant('books.type.article'); }
      default : { return this._t.instant('books.type.book') }
    }
  }

  getBookBinding(booktype: string): string | null {
    switch (booktype) {
      case 'E' : { return this._t.instant('books.binding.bound'); }
      case 'D' : { return this._t.instant('books.binding.doctrine'); }
      case 'R' : { return this._t.instant('books.binding.rustic_cover'); }
      default : { return null }
    }
  }

}
